import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  SEARCH_TILE: {
    GET_DASHBOARD_EVENT: (skip, query) => ({ skip, query }),
    API: {
      GET_DASHBOARD_EVENT: apiResourceActionCreator('dashboardEvent')
    }
  }
})

export const apiAction = (authToken, skip, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}), skip })}`, authToken, actions.searchTile.api.getDashboardEvent)

export function* getDashboardEvent(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.skip, action.payload && action.payload.query));
}

const configuration = {
  name: 'getDashboardEvent',
  action: actions,
  sagas: getDashboardEvent,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        isFetching: true
      });
    },
    success: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        dashboardEvent: action.payload.dashboardEvent,
        error: null
      });
    },
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/search-tile/configurations/getDashboardEvent.js